import { EHANDOVER_TAB_IDS } from '../constants/config';

// 生成 NewNotes 所有 tab 共用的 props。
// 这层只负责公共筛选、公共操作和页面级状态透传，不处理某个 tab 的特殊数据源。
export const createCommonNewNotesProps = ({
  accessControl,
  endDate,
  filterAPI,
  handleReset,
  individualUsers,
  pinTaskAPI,
  quickDays,
  refreshChecklistTabs,
  requiredAcknowLedge,
  search,
  selectedTags,
  setEndDate,
  setPendingAction,
  setQuickDays,
  setRequiredAcknowLedge,
  setSearch,
  setSelectedTags,
  setSortOrder,
  setStartDate,
  sortOrder,
  staffList,
  startDate,
  tagList,
  setHideCompletedItem,
  isHideCompletedItem,
  showHideCompleteItem,
  scrollableRef

}) => {
  return {
    accessControl,
    endDate,
    filterAPI,
    handleReset,
    individualUsers,
    pinTaskAPI,
    quickDays,
    refreshChecklistTabs,
    requiredAcknowLedge,
    search,
    selectedTags,
    setEndDate,
    setPendingAction,
    setQuickDays,
    setRequiredAcknowLedge,
    setSearch,
    setSelectedTags,
    setSortOrder,
    setStartDate,
    sortOrder,
    staffList,
    startDate,
    tagList,
    setHideCompletedItem,
    isHideCompletedItem,
    showHideCompleteItem,
    scrollableRef

  };
};

// 根据 tab type 补齐 NewNotes 的差异化 props。
// 这里保留 switch，是因为 EHandover 每个 tab 的数据源和少量特殊 props 不完全一致，
// 用显式分支会比过度抽象的配置表更直白，也更适合后续维护。
export const getNotesPropsByType = ({
  commonProps,
  deleteTaskAPI,
  followUpFilter,
  followUpTotal,
  getAcknowledgeTaskAPI,
  getAllTaskAPI,
  getChecklistTaskAPI,
  getCompleteTask,
  getDeletedTaskAPI,
  getMyDraftTask,
  getNotificationList,
  getOutstandingTask,
  getPinnedTask,
  getPostdayTaskAPI,
  handleFollowUpFilter,
  notesData,
  pinNotiAPI,
  type,
}) => {
  const notesProps = {
    ...commonProps,
    type,
  };

  switch (type) {
    case 'task':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.SENT_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.SENT_TAB].next;
      notesProps.getTaskListAPI = getAllTaskAPI;
      notesProps.deleteTaskAPI = deleteTaskAPI;
      break;
    case 'followUp':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.CHECKLIST_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.CHECKLIST_TAB].next;
      notesProps.getTaskListAPI = getChecklistTaskAPI;
      notesProps.deleteTaskAPI = deleteTaskAPI;
      notesProps.handleFollowUpFilter = handleFollowUpFilter;
      notesProps.followUpTotal = followUpTotal;
      notesProps.followUpFilter = followUpFilter;
      break;
    case 'deleted':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.DELETED_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.DELETED_TAB].next;
      notesProps.getTaskListAPI = getDeletedTaskAPI;
      break;
    case 'postDay':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.SCHEDULE_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.SCHEDULE_TAB].next;
      notesProps.getTaskListAPI = getPostdayTaskAPI;
      notesProps.deleteTaskAPI = deleteTaskAPI;
      break;
    case 'notification':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.NOTIFICATION_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.NOTIFICATION_TAB].next;
      notesProps.getTaskListAPI = getNotificationList;
      notesProps.pinTaskAPI = pinNotiAPI;
      break;
    case 'outstanding':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.OUTSTANDING_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.OUTSTANDING_TAB].next;
      notesProps.getTaskListAPI = getOutstandingTask;
      notesProps.deleteTaskAPI = deleteTaskAPI;
      break;
    case 'complete':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.COMPLETED_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.COMPLETED_TAB].next;
      notesProps.getTaskListAPI = getCompleteTask;
      notesProps.deleteTaskAPI = deleteTaskAPI;
      notesProps.showHideCompleteItem = false;
      break;
    case 'pinned':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.PIN_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.PIN_TAB].next;
      notesProps.getTaskListAPI = getPinnedTask;
      notesProps.deleteTaskAPI = deleteTaskAPI;
      break;
    case 'myDraft':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.MY_DRAFT_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.MY_DRAFT_TAB].next;
      notesProps.getTaskListAPI = getMyDraftTask;
      notesProps.deleteTaskAPI = deleteTaskAPI;
      break;
    case 'requireAck':
      notesProps.notes = notesData[EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB].list;
      notesProps.next = notesData[EHANDOVER_TAB_IDS.REQUIRE_ACK_TAB].next;
      notesProps.getTaskListAPI = getAcknowledgeTaskAPI;
      notesProps.deleteTaskAPI = deleteTaskAPI;
      break;
    default:
      break;
  }

  return notesProps;
};

// 把展示中的 tab 数据映射成真正传给 TabBar 的结构。
// 这里保留“字符串类型的 component 需要即时实例化”的原有约束，避免影响现有渲染行为。
export const mapTabDataWithComponents = ({ displayTabData, renderTabNotes }) => {
  return displayTabData.map((item) => ({
    ...item,
    component: typeof item.component === 'string' ? renderTabNotes(item.component) : item.component,
  }));
};
